<template>
  <div class="store_wrapper">
    <main v-if="branches && branches.length">
      <v-data-table
        class="thumb strip"
        :headers="headers"
        :items="branches"
        :custom-filter="helper_filterSearch"
        :loading="loading_table"
        :loading-text="$t('table.loadingData')"
        item-key="id"
        hide-default-footer
      >
        <!-- ================== You Can use any slots you want ================== -->
        <!-- ====== Select row field ====== -->
        <!-- Image -->
        <template v-slot:[`item.avatar`]="{ item }">
          <div v-if="item.avatar">
            <img class="image" :src="item.avatar" @click="show_model_1" />
          </div>
        </template>

        <template v-slot:[`item.index`]="{ index }">
          {{ index + 1 }}
        </template>

        <!-- Select no data State -->
        <template v-slot:no-data>
          {{ $t("table.noData") }}
        </template>
        <template v-slot:[`item.is_active`]="{ item }">
          <v-btn
            @click="toggleStatusModel(item)"
            :color="item.is_active ? 'success' : 'error'"
            >{{ item.is_active ? "فعال" : "غير فعال" }}</v-btn
          >
        </template>
        <template v-slot:[`item.city`]="{ item }">
          <div>
            <span>{{ item.city?.name }}</span>
            <button class="btn" @click="showBrnachLocation(item)">
              <i class="fal fa-eye"></i>
            </button>
          </div>
        </template>

        <!-- IsActive -->
        <!-- <template v-slot:[`item.is_active`]="{ item }">
            <span class="status" :class="item.is_active ? 'paid' : 'unpaid'">
              {{ item.is_active ? "مفعل" : "معطل" }}
            </span>
          </template> -->
        <!-- <template v-slot:[`item.fullname`]="{ item }">
            <span v-if="!item.fullname || item.fullname == ''">لا يوجد</span>
            <span>{{ item.fullname }}</span>
          </template> -->
        <!-- <template v-slot:[`item.phone`]="{ item }">
            <span v-if="!item.phone || item.phone == ''">لا يوجد</span>
            <span>{{ item.phone_code + item.phone }}</span>
          </template> -->
        <!-- Select actions-->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="_actions">
            <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon>
            <v-icon class="edit" small @click="editItem(item)">
              fal fa-edit
            </v-icon>
            <!-- <v-icon class="delete" small @click="deleteItem(item)">
              fal fa-trash
            </v-icon> -->
          </div>
        </template>

        <!-- ======================== Start Top Section ======================== -->
        <template v-slot:top>
          <div class="d-flex justify-content-between">
            <h3 class="table-title title">الفروع</h3>
            <button class="btn add_branch_btn" @click="$emit('addBranch')">
              <span class="ml-3"><i class="fal fa-plus"></i></span>
              <span>إضافة فرع</span>
            </button>
          </div>
          <!-- Delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("table.deletedialog.areYouSure") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="deleteItemConfirm">
                  {{ $t("table.deletedialog.ok") }}
                </v-btn>
                <v-btn color="#F44336" @click="dialogDelete = false">
                  {{ $t("table.deletedialog.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="locationDialog" width="800px">
            <v-card class="p-0">
              <div class="main_border" style="height: 500px">
                <GmapMap
                  style="width: 100%; height: 100%"
                  :zoom="10"
                  :center="{ lat: +location.lat, lng: +location.lng }"
                  ref="map"
                >
                  <GmapMarker
                    :position="{ lat: +location.lat, lng: +location.lng }"
                    :draggable="false"
                  />
                </GmapMap>
              </div>
            </v-card>
          </v-dialog>

          <!-- Add & Delete -->
          <v-row>
            <v-col cols="12" sm="8"></v-col>
          </v-row>
        </template>
        <!-- ======================== End Top Section ======================== -->
      </v-data-table>
    </main>

    <div v-else class="no_branches">
      <div>لا يوجد فروع لهذا المتجر</div>
      <div class="no_branches_img"><i class="fas fa-store-alt-slash"></i></div>
      <button class="btn add_branch_btn" @click="$emit('addBranch')">
        <span class="ml-3"><i class="fal fa-plus"></i></span>
        <span>إضافة فرع</span>
      </button>
    </div>
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
    <v-dialog v-model="statusModel" width="500">
      <v-card class="p-4" v-if="statusItem">
        <h5 v-if="statusItem.is_active">هو تود الغاء تفعيل هذا المتجر؟</h5>
        <h5 v-else>هو تود تفعيل هذا المتجر؟</h5>

        <textarea
          v-if="statusItem.is_active"
          v-model="deactive_reason"
          placeholder="السبب ..."
          class="deactive_reason mt-5 px-3"
        ></textarea>
        <div class="text-center mt-5">
          <v-btn
            class="ml-2 px-10"
            @click="changeStatus"
            :color="statusItem.is_active ? 'error' : 'success'"
            >نعم</v-btn
          >
          <v-btn
            class="mr-2 px-10"
            @click="statusModel = false"
            :color="statusItem.is_active ? 'success' : 'error'"
            >لا</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      location: { lat: null, lng: null },
      locationDialog: false,
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      statusModel: false,
      statusItem: null,
      deactive_reason: null,
      branches: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "center",
          value: "index",
          sortable: true,
        },
        {
          text: "الصورة",
          align: "center",
          value: "avatar",
          sortable: false,
        },
        {
          text: "الاسم",
          value: "full_name",
          align: "center",
        },
        // {
        //   text: "اسم المستخدم",
        //   value: "user_name",
        //   align: "center",
        // },

        {
          text: "رقم الهاتف",
          value: "phone_complete_form",
          align: "center",
        },
        {
          text: "المدينة",
          value: "city",
          align: "center",
        },

        {
          text: "حالة التفعيل",
          value: "is_active",
          align: "center",
        },
        {
          text: "التحكم",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    toggleStatusModel(item) {
      this.statusModel = true;
      this.statusItem = item;
    },
    changeStatus() {
      if (this.statusItem.is_active && !this.deactive_reason) {
        this.$iziToast.error({
          message: "يرجي ادخال سبب الغاء التفعيل اولا",
          timeout: 5000,
          position: "bottomRight",
        });
        return;
      }
      const formData = new FormData();
      formData.append("is_active", this.statusItem.is_active ? 0 : 1);
      if (this.deactive_reason) {
        formData.append("message", this.deactive_reason);
      }
      formData.append("_method", "PUT");

      console.log(this.statusItem);
      this.$axios({
        method: "POST",
        url: `/store/is_active/${this.statusItem.id}`,
        data: formData,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.statusModel = false;
          this.$emit("get_store");
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
        });
    },
    editItem(item) {
      this.$emit("editBranch", item);
    },
    showItem(item) {
      this.$emit("showBranch", item);
    },
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    showBrnachLocation(item) {
      this.location = item;
      this.locationDialog = true;
    },
    getBranches() {
      this.data.loading = true;
      this.$axios({
        method: "GET",
        url: `store/branch/${this.$route.params.id}`,
      })
        .then((res) => {
          this.branches = res.data.data;

          this.data.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.data.loading = false;
        });
    },
  },
  mounted() {
    this.getBranches();
  },
};
</script>
<style lang="scss" scoped>
.store_wrapper {
  padding: 1rem;
  @include mainShadow;
  border-radius: 15px;
}
.add_branch_btn {
  color: gray;
  font-size: 1.3rem;
  display: inline-block;
  margin: 10px;
  @include mainShadow;
}
.no_branches {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.5rem;
  //   font-weight: bold;
  color: gray;
  .no_branches_img {
    font-size: 10rem;
    color: var(--mainColor-2);
  }
  .btn {
    padding-inline: 3rem;
    background: var(--mainColor-2);
    color: white;
  }
}
</style>
